import { render, staticRenderFns } from "./InfluencerProfile.vue?vue&type=template&id=643865fc&scoped=true"
import script from "./InfluencerProfile.vue?vue&type=script&lang=js"
export * from "./InfluencerProfile.vue?vue&type=script&lang=js"
import style0 from "./InfluencerProfile.vue?vue&type=style&index=0&id=643865fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643865fc",
  null
  
)

export default component.exports